const gtagId = 'UA-111413542-5',
  placeHolderImg = 'placeholder.jpg'
export { gtagId, placeHolderImg }
